// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo___1Q44T","right_menu":"right_menu___2u7vb","navbar_toggle":"navbar_toggle___kjSWO","navbar_toggle_icon":"navbar_toggle_icon___3JDiH"};